import React, { Component } from "react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import {
  Form,
  FormItem,
  ModalItem,
  ButtonItem,
  ErrorItem,
  TextAreaItem,
} from "../../../../Components/Items";

class ElegirLeyenda extends Component {
  dropdownRef = React.createRef();
  formRefLeyenda = React.createRef();
  containerRef = React.createRef(); // wrapper relativo del textarea

  state = {
    loading: false,
    leyendasPasadas: [],
    leyendaValue: "",
    sugerencias: [],
    showSugerencias: false,
    activeIndex: -1,

    // posición para el dropdown (para portal)
    dropPos: { top: 0, left: 0, width: 0 },
  };

  debounceTimer = null;

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside, true);
    window.addEventListener("resize", this.reposicionarDropdown, true);
    window.addEventListener("scroll", this.reposicionarDropdown, true);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside, true);
    window.removeEventListener("resize", this.reposicionarDropdown, true);
    window.removeEventListener("scroll", this.reposicionarDropdown, true);
    if (this.debounceTimer) clearTimeout(this.debounceTimer);
  }
  /*
    componentDidUpdate(prevProps) {
        if (this.props.visible !== prevProps.visible && this.props.visible) {
            const leyendas = Array.isArray(this.props.leyendasPasadas)
                ? this.props.leyendasPasadas
                : [];

            const unicas = Array.from(
                new Set(leyendas.map((x) => (x || "").trim()).filter(Boolean))
            );

            const leyendaInicial = this.props.leyenda || "";

            this.formRefLeyenda.current?.setFieldsValue({ leyenda: leyendaInicial });

            this.setState({
                leyendasPasadas: unicas,
                leyendaValue: leyendaInicial,
                sugerencias: [],
                showSugerencias: false,
                activeIndex: -1,
            });
        }

        if (this.props.visible !== prevProps.visible && !this.props.visible) {
            this.setState({
                sugerencias: [],
                showSugerencias: false,
                activeIndex: -1,
            });
        }
    }*/

  componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible && this.props.visible) {
      const leyendasRaw = Array.isArray(this.props.leyendasPasadas)
        ? this.props.leyendasPasadas
        : [];

      const mapUnicas = new Map();
      leyendasRaw.forEach((item) => {
        let obj;
        // Si es un string viejo
        if (typeof item === "string") {
          obj = { texto: item.trim(), generica: true };
        }
        // Si es un objeto nuevo
        else if (item && item.texto) {
          obj = {
            texto: item.texto.trim(),
            clienteId: item.clienteId,
            nombreCliente: item.nombreCliente,
            generica: false,
          };
        } else return; // ignorar si viene mal formateado

        if (obj.texto && !mapUnicas.has(obj.texto)) {
          mapUnicas.set(obj.texto, obj);
        }
      });

      let unicas = Array.from(mapUnicas.values());

      // ORDENAMIENTO: Cliente Actual, Genéricas, Otros Clientes
      unicas.sort((a, b) => {
        const esClienteA = a.clienteId === this.props.clienteIdActual;
        const esClienteB = b.clienteId === this.props.clienteIdActual;

        if (esClienteA && !esClienteB) return -1;
        if (!esClienteA && esClienteB) return 1;
        if (a.generica && !b.generica) return -1;
        if (!a.generica && b.generica) return 1;
        return 0;
      });

      const leyendaInicial = this.props.leyenda || "";
      this.formRefLeyenda.current?.setFieldsValue({ leyenda: leyendaInicial });

      this.setState({
        leyendasPasadas: unicas,
        leyendaValue: leyendaInicial,
        sugerencias: [],
        showSugerencias: false,
        activeIndex: -1,
      });
    }

    if (this.props.visible !== prevProps.visible && !this.props.visible) {
      this.setState({
        sugerencias: [],
        showSugerencias: false,
        activeIndex: -1,
      });
    }
  }

  reposicionarDropdown = () => {
    if (!this.state.showSugerencias) return;
    const node = this.containerRef.current;
    if (!node) return;

    const r = node.getBoundingClientRect();
    this.setState({
      dropPos: {
        top: r.bottom + 6,
        left: r.left,
        width: r.width,
      },
    });
  };

  handleClickOutside = (e) => {
    if (!this.state.showSugerencias) return;

    const inputWrap = this.containerRef.current;
    const dropdown = this.dropdownRef.current;

    const clickEnInput = inputWrap && inputWrap.contains(e.target);
    const clickEnDropdown = dropdown && dropdown.contains(e.target);

    if (!clickEnInput && !clickEnDropdown) {
      this.setState({ showSugerencias: false });
    }
  };

  setLeyendaEnForm = (value) => {
    this.formRefLeyenda.current?.setFieldsValue({ leyenda: value });
  };

  filtrarSugerencias = (query) => {
    const q = (query || "").trim();
    const qUp = q.toUpperCase();

    // Si no hay query: muestra “top” (primeras 10)
    if (!qUp) return this.state.leyendasPasadas.slice(0, 10);

    const starts = [];
    const includes = [];

    for (const l of this.state.leyendasPasadas) {
      const lu = (l.texto || "").toUpperCase();
      if (lu.startsWith(qUp)) starts.push(l);
      else if (lu.includes(qUp)) includes.push(l);
      if (starts.length + includes.length >= 10) break;
    }

    return [...starts, ...includes].slice(0, 10);
  };

  onChangeLeyenda = (e) => {
    const value = e?.target?.value ?? "";

    this.setState({
      leyendaValue: value,
      activeIndex: -1,
    });
    this.setLeyendaEnForm(value);

    // Abrir dropdown mientras escribe
    if (!this.state.showSugerencias) {
      this.setState({ showSugerencias: true }, this.reposicionarDropdown);
    }

    if (this.debounceTimer) clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(() => {
      const sugerencias = this.filtrarSugerencias(value);
      this.setState(
        {
          sugerencias,
          showSugerencias: sugerencias.length > 0,
          activeIndex: -1,
        },
        this.reposicionarDropdown,
      );
    }, 120);
  };

  // ✅ NUEVO: al hacer click/focus, muestra lista (aunque esté vacío)
  onFocusLeyenda = () => {
    const sugerencias = this.filtrarSugerencias(this.state.leyendaValue);
    this.setState(
      {
        sugerencias,
        showSugerencias: sugerencias.length > 0,
        activeIndex: -1,
      },
      this.reposicionarDropdown,
    );
  };

  seleccionarSugerencia = (sugerenciaObj) => {
    const texto = sugerenciaObj.texto;
    this.setState({
      leyendaValue: texto,
      sugerencias: [],
      showSugerencias: false,
      activeIndex: -1,
    });
    this.setLeyendaEnForm(texto);
  };

  onKeyDownLeyenda = (e) => {
    const { showSugerencias, sugerencias, activeIndex } = this.state;

    if (!showSugerencias || !sugerencias.length) {
      if (e.key === "Escape") this.setState({ showSugerencias: false });
      return;
    }

    const max = sugerencias.length - 1;

    if (e.key === "ArrowDown") {
      e.preventDefault();
      this.setState({
        activeIndex: activeIndex < 0 ? 0 : Math.min(max, activeIndex + 1),
      });
      return;
    }

    if (e.key === "ArrowUp") {
      e.preventDefault();
      this.setState({
        activeIndex: activeIndex < 0 ? max : Math.max(0, activeIndex - 1),
      });
      return;
    }

    if (e.key === "Enter") {
      if (activeIndex >= 0) {
        e.preventDefault();
        const pick = sugerencias[activeIndex];
        if (pick) this.seleccionarSugerencia(pick);
      }
      return;
    }

    if (e.key === "Escape") {
      e.preventDefault();
      this.setState({ showSugerencias: false });
    }
  };

  renderSugerenciasPortal() {
    const { showSugerencias, sugerencias, activeIndex, dropPos } = this.state;
    if (!showSugerencias || !sugerencias.length) return null;

    const dropdown = (
      <div
        style={{
          position: "fixed",
          top: dropPos.top,
          left: dropPos.left,
          width: dropPos.width,
          zIndex: 2000, // arriba del Modal (antd suele ser 1000)
          background: "#fff",
          border: "1px solid #e5e5e5",
          borderRadius: 6,
          boxShadow: "0 6px 18px rgba(0,0,0,0.12)",
          maxHeight: 220,
          overflowY: "auto",
        }}
        ref={this.dropdownRef}
      >
        {sugerencias.map((sug, idx) => {
          const active = idx === activeIndex;
          const esClienteActual = sug.clienteId === this.props.clienteIdActual;
          let bgColor = active ? "#f5f5f5" : "#fff";
          if (esClienteActual) {
            bgColor = active ? "#d9f7be" : "#f6ffed"; // verde claro para cliente actual
          }
          return (
            <div
              key={`${sug}-${idx}`}
              onClick={(e) => {
                e.preventDefault(); // evita que el input pierda foco
                e.stopPropagation();
                this.seleccionarSugerencia(sug);
              }}
              style={{
                padding: "10px 12px",
                cursor: "pointer",
                background:bgColor,
                borderBottom:
                  idx === sugerencias.length - 1 ? "none" : "1px solid #f0f0f0",
                whiteSpace: "pre-wrap",
              }}
              title={sug.texto}
            >
              <div
                style={{
                  whiteSpace: "pre-wrap",
                  fontWeight: esClienteActual ? "500" : "normal",
                }}
              >
                {sug.texto}
              </div>
              <div
                style={{
                  fontSize: "11px",
                  color: esClienteActual ? "#389e0d" : "#8c8c8c",
                  marginTop: "4px",
                }}
              >
                {sug.generica
                  ? ""
                  : esClienteActual
                    ? `• Usada con este cliente`
                    : `• Usada con ${sug.nombreCliente}`}
              </div>
            </div>
          );
        })}
      </div>
    );

    return ReactDOM.createPortal(dropdown, document.body);
  }

  cerrarElegirLeyenda() {
    const leyenda =
      this.formRefLeyenda.current?.getFieldValue("leyenda") ??
      this.state.leyendaValue;

    this.props.cerrarElegirLeyenda(leyenda);
    this.formRefLeyenda.current?.resetFields();

    this.setState({
      leyendaValue: "",
      sugerencias: [],
      showSugerencias: false,
      activeIndex: -1,
    });
  }

  onFinish() {
    this.cerrarElegirLeyenda();
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  render() {
    return (
      <>
        <ModalItem
          title="Leyenda"
          visible={this.props.visible}
          spinning={this.state.loading}
          onCancel={this.cerrarElegirLeyenda.bind(this)}
          paddingTop
          width={700}
        >
          <Form
            ref={this.formRefLeyenda}
            name="elegirLeyenda"
            layout
            bottom={
              <ButtonItem
                type="primary"
                htmlType="submit"
                style={{ display: "block", margin: "0 0 0 auto" }}
              >
                Guardar
              </ButtonItem>
            }
            onFinish={this.onFinish.bind(this)}
            onFinishFailed={this.onFinishFailed}
          >
            <FormItem name="leyenda" label="Leyenda" pattern margin>
              <div ref={this.containerRef}>
                <TextAreaItem
                  placeholder="Escribe una leyenda"
                  autoSize={{ minRows: 3, maxRows: 8 }}
                  value={this.state.leyendaValue}
                  onChange={this.onChangeLeyenda}
                  onKeyDown={this.onKeyDownLeyenda}
                  onFocus={this.onFocusLeyenda}
                  onClick={this.onFocusLeyenda}
                />
              </div>
            </FormItem>

            {/* ✅ Dropdown en portal para que NO se corte por el modal */}
            {this.renderSugerenciasPortal()}

            {this.props.textoDinamicas && (
              <div class="styled-list">
                <h3>Textos dinámicos</h3>
                <table>
                  <tr>
                    <td>
                      <code>&lt;Mes&gt;</code>
                    </td>
                    <td>Mes de venta (Enero, Febrero, etc.)</td>
                  </tr>
                  <tr>
                    <td>
                      <code>&lt;MesCo&gt;</code>
                    </td>
                    <td>Mes de venta corto (Ene, Feb, etc.)</td>
                  </tr>
                  <tr>
                    <td>
                      <code>&lt;MesNum&gt;</code>
                    </td>
                    <td>Mes de venta en número (01, 02, etc.)</td>
                  </tr>
                  <tr>
                    <td>
                      <code>&lt;MesAn&gt;</code>
                    </td>
                    <td>Mes anterior (Enero, Febrero, etc.)</td>
                  </tr>
                  <tr>
                    <td>
                      <code>&lt;MesAnCo&gt;</code>
                    </td>
                    <td>Mes anterior corto (Ene, Feb, etc.)</td>
                  </tr>
                  <tr>
                    <td>
                      <code>&lt;MesAnNum&gt;</code>
                    </td>
                    <td>Mes anterior en número (01, 02, etc.)</td>
                  </tr>
                  <tr>
                    <td>
                      <code>&lt;MesSig&gt;</code>
                    </td>
                    <td>Mes siguiente (Enero, Febrero, etc.)</td>
                  </tr>
                  <tr>
                    <td>
                      <code>&lt;MesSigCo&gt;</code>
                    </td>
                    <td>Mes siguiente corto (Ene, Feb, etc.)</td>
                  </tr>
                  <tr>
                    <td>
                      <code>&lt;MesSigNum&gt;</code>
                    </td>
                    <td>Mes siguiente en número (01, 02, etc.)</td>
                  </tr>
                  <tr>
                    <td>
                      <code>&lt;Anio&gt;</code>
                    </td>
                    <td>Año de venta (2025, 2026, etc.)</td>
                  </tr>
                  <tr>
                    <td>
                      <code>&lt;Fecha&gt;</code>
                    </td>
                    <td>Fecha de venta (01/01/2025)</td>
                  </tr>
                  <tr>
                    <td>
                      <code>&lt;Dia&gt;</code>
                    </td>
                    <td>Día de venta (01, 02, etc.)</td>
                  </tr>
                  <tr>
                    <td>
                      <code>&lt;DiaSemana&gt;</code>
                    </td>
                    <td>Día de la semana (Lunes, Martes, etc.)</td>
                  </tr>
                  <tr>
                    <td>
                      <code>&lt;SemanaLa&gt;</code>
                    </td>
                    <td>
                      Descripción semana empezando en Lunes (Ej. 28 abril al 4
                      mayo)
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <code>&lt;SemanaAnLa&gt;</code>
                    </td>
                    <td>
                      Descripción semana anterior empezando en Lunes (Ej. 21 al
                      27 de abril)
                    </td>
                  </tr>
                </table>
              </div>
            )}
          </Form>
        </ModalItem>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(ElegirLeyenda);
